import * as React from 'react'
import styled from 'styled-components'
import { Modal } from 'react-bootstrap'
import { media } from '../../utils'
import ContainerProps from './Resources'

interface Props extends ContainerProps {
  open: boolean
  onHide?: () => void
  animation?: boolean
  type?: string
}

export const LargeModal = (props: Props) => {
  const { open, onHide, animation, children, type } = props
  if(type === "OBITUARY" || type === "CARD"){
    return (
      <Modal
        className='product-modal'
        show={open}
        animation={animation}
        backdropClassName='modal-backdrop dark-modal in'>
        {children}
      </Modal>
    )
  }else{
    return (
      <Modal
        className='product-modal'
        show={open}
        onHide={onHide}
        animation={animation}
        backdropClassName='modal-backdrop dark-modal in'>
        {children}
      </Modal>
    )
  }
}

export const ModalHeader = styled(Modal.Header)`
  position: relative;
  margin-top: 30px;
  margin-bottom: 15px;
`

export const ModalTitle = styled(Modal.Title)`
    text-align: center;
    font-weight: bold;
    margin-top: 15px;
    margin-bottom: 5px;
    color: #4A4A4A;

    ${media.giant`font-size: 32px;`}
    ${media.desktop`font-size: 26px;`}
    ${media.phone`
        word-break: break-word;
        hyphens: auto;
    `}
`

export const ModalContent = styled(Modal.Body)``
export const ModalFooter = styled(Modal.Footer)``

export default LargeModal



// WEBPACK FOOTER //
// ./src/components/containers/LargeModal.tsx